import { render, staticRenderFns } from "./BookDictionary.vue?vue&type=template&id=7004c9e4&"
import script from "./BookDictionary.vue?vue&type=script&lang=js&"
export * from "./BookDictionary.vue?vue&type=script&lang=js&"
import style0 from "./BookDictionary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports